import { render } from "./gallery.svg?vue&type=template&id=ad7f525a"
const script = {}

import exportComponent from "/codebuild/output/src377198440/src/2021-facebook-ang-immersivepainting/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__